"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuitGameButton = exports.Settings = void 0;
var settings_1 = require("./settings");
Object.defineProperty(exports, "Settings", { enumerable: true, get: function () { return settings_1.Settings; } });
var quitGameButton_1 = require("./quitGameButton");
Object.defineProperty(exports, "QuitGameButton", { enumerable: true, get: function () { return quitGameButton_1.QuitGameButton; } });
